module.exports = __webpack_public_path__ + "img/mailchimp.ee2a750d.png";